import React from 'react';
import { CRM_LOGOS } from '../data/mock';

export default function CrmMarquee() {
  // Duplicate for seamless loop
  const logos = [...CRM_LOGOS, ...CRM_LOGOS];
  return (
    <div className="relative overflow-hidden py-4">
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
      <div className="flex w-max gap-10 animate-scroll-x">
        {logos.map((logo, i) => (
          <div
            key={`${logo.name}-${i}`}
            className="flex items-center justify-center min-w-[140px] h-20 px-4 grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
            title={logo.name}
          >
            <img
              src={logo.img}
              alt={logo.name}
              className="max-h-12 w-auto object-contain"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
